import { ecomAPI } from './Axios'
import { filterImpersonationMetadataFromOrder } from '../helpers/utils'

export const OrderFecther = (url) =>
    ecomAPI.get(url).then((res) => {
        // Filter out impersonation metadata before returning to frontend
        if (res.data) {
            return filterImpersonationMetadataFromOrder(res.data)
        }
        return res.data
    })

export const OrderAPI = {
    runReuploadOffers(order_id) {
        return ecomAPI.post('?url=RunROSAutomationOnReupload', { order_id })
    },

    create(order) {
        return ecomAPI.post('?url=orders', order)
    },

    update(id, data) {
        return ecomAPI.put(`?url=orders/${id}`, data)
    },

    async get(id) {
        const response = await ecomAPI.get(`?url=orders/${id}`)
        // Filter out impersonation metadata before returning to frontend
        if (response.data) {
            response.data = filterImpersonationMetadataFromOrder(response.data)
        }
        return response
    },

    _create(data) {
        return ecomAPI.post('?url=orders', data)
    },

    createCustomer(data) {
        return ecomAPI.post('?url=customers', data)
    },

    searchCustomerByEmail(email) {
        return ecomAPI.get(`?url=customers?email=${email}`)
    },

    searchCoupon(coupon) {
        return ecomAPI.get(`?url=coupons&search=${coupon}`)
    },

    applyCoupon(data) {
        return ecomAPI.post('?url=applyCoupon', data)
    },

    removeCoupons(data) {
        return ecomAPI.post('?url=removeCoupons', data)
    },

    updateProcessingFee(order_id, apply_fee = true) {
        return ecomAPI.post('?url=updateProcessingFee', { order_id, apply_fee })
    },

    handleDuplicateOrder(data) {
        return ecomAPI.post('?url=handleDuplicateOrder', data)
    },

    sendReuploadMail(data) {
        return ecomAPI.post('?url=sendReuploadMail', data)
    },

    getCustomerByOrder(order) {
        const customer_id = order.customer_id
        return ecomAPI.get('?url=customers', { id: customer_id })
    },

    async getLatestDeliverableFile(order_id) {
        const { data } = await ecomAPI.post('?url=latest-deliverable-file', {
            order_id,
        })
        // this return url of file
        return data
    },
}
